import { ComponentPropsWithRef, memo } from 'react'

import { Slot } from '@radix-ui/react-slot'

import { cn } from '@/shared/lib/cn'

interface LinkBoxProps extends ComponentPropsWithRef<'article'> {
	asChild?: boolean
}

export const LinkBox = memo(
	({ ref, asChild = false, className, ...props }: LinkBoxProps) => {
		const Comp = asChild ? Slot : 'article'

		return (
			<Comp
				ref={ref}
				className={cn(
					'wwt-linkbox relative',
					'[&>a[href]:not(.wwt-linkbox__overlay)]:relative [&>a[href]:not(.wwt-linkbox__overlay)]:z-1',
					className
				)}
				{...props}
			/>
		)
	}
)

LinkBox.displayName = 'LinkBox'
